import Vue from 'vue'
import VueI18n from 'vue-i18n'
import { setLanguage } from '../api/basicData';
import { searchReqParam } from '../utils/searchReqParam';

Vue.use(VueI18n)

let locale = window.localStorage.getItem('locale')
const userLang = locale || navigator.language || navigator.userLanguage;
if (userLang.includes('zh')) {
    locale = 'zh_CN';
} else if (userLang.includes('vi')) {
    locale = 'vi_VN';
} else {
  locale = 'en_US';
}
window.localStorage.setItem('locale', locale)

export const locales = [
  { value: "zh_CN", label: "简体中文", emoji: ':cn:', data: require('./zh_CN.json') },
  { value: "vi_VN", label: "Tiếng Việt", emoji: ':flag-vn:', data: require('./vi_VN.json') },
  { value: "en_US", label: "English", emoji: ':us:', data: require('./en_US.json') },
]

const messages = locales.reduce((acc, curr) => {
  acc[curr.value] = curr.data;
  return acc;
}, {});

const i18n = new VueI18n({
  locale, // 默认语言
  messages
})


export function setLocale(language) {
  i18n.locale = language
  setLanguage(searchReqParam({ language })).then(() => {
    window.localStorage.setItem("locale", language)
    location.reload();
  })
}


export default i18n